/**
 * i18n 多語系配置
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 匯入語系檔案
import translationZhTW from './locales/zh-TW/translation.json';
import translationEn from './locales/en/translation.json';

// 語系資源
const resources = {
  'zh-TW': {
    translation: translationZhTW,
  },
  en: {
    translation: translationEn,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    supportedLngs: ['zh-TW', 'en'],
    ns: ['translation'],
    defaultNS: 'translation',
  });

export default i18n;
